import { stripLeadingLocalePath } from '@/lib/network';

/** The marketing home uses its own navigation; demo-mode routes keep the app header. */
export function isSimpleHeaderRoute(pathname: string): boolean {
  return stripLeadingLocalePath(pathname) === '/';
}
